<template>
    <form @change="sendDataForSaving">
        <div class="dashed-border-block">
            <div class="text-center">
                <h6>List below additional, current or formal employee references (not personal friends)</h6>
            </div>
            <div>

                <EmployeeReferences
                    v-for="(reference) in form.references"
                    :reference.sync="reference"
                    :key="reference.id"
                    @delete-reference="deleteReference"
                    :lengthRef="form.references.length"
                    :user="user"
                ></EmployeeReferences>

            </div>
            <div class="add-row text-right">
                <button class="add-link" @click.prevent="addReference">+ Add another</button>
            </div>
        </div>
        <div class="dashed-border-block">
            <div class="text-center">
                <h6>Emergency Contacts</h6>
                <p>Providing the information means that you give ORNA permission to contact all names listed below
                    if necessary</p>
            </div>

            <EmergencyContacts
                v-for="(contact) in form.contacts"
                :contact.sync="contact"
                :key="contact.id"
                :lengthCnt="form.contacts.length"
                @delete-contact="deleteContact"
                :user="user"
            ></EmergencyContacts>

            <div class="add-row text-right">
                <button class="add-link" @click.prevent="addContact">+ Add another</button>
            </div>
        </div>
    </form>
</template>

<script>
import EmergencyContacts from "./EmergencyContacts.vue";
import EmployeeReferences from "./EmployeeReferences.vue";
import EmergencyContactsService from "../services/EmergencyContactsService";
import EmployeeReferencesService from "../services/EmployeeReferencesService";

export  default {
    name: 'ReferencesForm',
    components: {
        EmployeeReferences,
        EmergencyContacts
    },
    emits: ['data-changed'],
    props: {
        user: {
            type: Object
        }
    },
    data() {
        return {
            form: {
                references: this.user.employee_references ??[],
                contacts: this.user.emergency_contacts ?? [],
            },
        }
    },
    methods :{
        addContact() {
            this.form.contacts.push({
                id: null,
                name: null,
                term_know: null,
                phone: null,
            })
        },
        addReference() {
            this.form.references.push({
                id: null,
                name: null,
                term_know: null,
                phone: null,
            })
        },
        async deleteContact(id) {
            this.form.contacts= this.form.contacts.filter((item) => item.id !== id)
            try {
                this.$showSuccessMessageDelete();
                await EmergencyContactsService.delete(id);

            } catch (error) {
            }
        },
        async deleteReference(id) {
            this.form.references= this.form.references.filter((item) => item.id !== id)
            try {
                this.$showSuccessMessageDelete();
                await EmployeeReferencesService.delete(id);

            } catch (error) {
            }
        },
        sendDataForSaving() {
            this.$emit('data-changed', this.form);
        },
    },
    mounted() {
        if ( this.form.references.length <= 0) {
            this.addReference();
        }
        if ( this.form.contacts.length <= 0) {
            this.addContact();
        }
    },

}

</script>

<style scoped>

</style>
